import React from 'react'
import { TiWarningOutline } from "react-icons/ti";
import Mainlayout from '../layout/Mainlayout'
export default function Loginreq() {


    return (

        <Mainlayout>

            
                <div className='text-center bg-dwam text-yellow-500 min-h-screen flex flex-col items-center '>

                    <TiWarningOutline className='w-1/3 h-1/3 drop-shadow-2xl' />
                    <h1 class="md:text-4xl text-xl font-extrabold "> پێویستە داخڵ ببیت بۆ بینینی ئەم پەڕەیە </h1>
                </div>


            
        </Mainlayout>

    )
}